import { render } from "./QuerySettings.vue?vue&type=template&id=447cfc51&scoped=true"
import script from "./QuerySettings.vue?vue&type=script&lang=js"
export * from "./QuerySettings.vue?vue&type=script&lang=js"

import "./QuerySettings.vue?vue&type=style&index=0&id=447cfc51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447cfc51"]])

export default __exports__